import { render, staticRenderFns } from "./Page_NZ_Brands.vue?vue&type=template&id=3644816b&scoped=true&"
import script from "./Page_NZ_Brands.vue?vue&type=script&lang=js&"
export * from "./Page_NZ_Brands.vue?vue&type=script&lang=js&"
import style0 from "./Page_NZ_Brands.vue?vue&type=style&index=0&id=3644816b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3644816b",
  null
  
)

export default component.exports